import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LoaderCircle } from "lucide-react";

type Props = {
  url: string;
};

export function ResetPasswordForm({ url }: Props) {
  const { data, setData, patch, processing, errors, reset, clearErrors } =
    useForm({
      password: "",
      password_confirmation: "",
    });

  function logIn(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    patch(url, {
      preserveScroll: "errors",
      onStart: () => clearErrors(),
      onError: () => reset(),
    });
  }

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Reset password</CardTitle>
          {errors.password && (
            <CardDescription className="text-destructive">
              {errors.password}
            </CardDescription>
          )}
        </CardHeader>
        <CardContent>
          <form onSubmit={logIn}>
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  name="password"
                  required
                  value={data.password}
                  onChange={(e) => setData("password", e.target.value)}
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="password">Password confirmation</Label>
                <Input
                  id="password_confirmation"
                  type="password"
                  name="password_confirmation"
                  required
                  value={data.password_confirmation}
                  onChange={(e) =>
                    setData("password_confirmation", e.target.value)
                  }
                />
              </div>
              <Button type="submit" className="w-full" disabled={processing}>
                {processing && <LoaderCircle className="animate-spin" />}
                Update password
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
